import {LoadingOverlay} from '@mantine/core';

export const LoadingOverlayTheme = LoadingOverlay.extend({
  defaultProps: {
    overlayProps: {
      radius: '6px',
    },
    loaderProps: {
      type: 'dots',
    },
  },
});